import { Dictionary } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { RedirectionViewState } from "../types";
import { RedirectionAction, RedirectionFailedAction, RegisterHandlerAction, ResetRedirectionAction } from "./actions";

export interface RedirectionState {
  viewState: RedirectionViewState | null;
  registeredDestionationHandlers: Dictionary<boolean>;
}

const initialState = {
  viewState: null,
  registeredDestionationHandlers: {},
};

export const reducer = createReducer<RedirectionState>(
  initialState,
  on(ResetRedirectionAction, () => initialState),
  on(RegisterHandlerAction, (state, action) => {
    return {
      ...state,
      registeredDestionationHandlers: {
        ...state.registeredDestionationHandlers,
        [action.destination]: true,
      },
    };
  }),
  on(RedirectionAction, (state, action) => {
    return {
      ...state,
      viewState: action.destination in state.registeredDestionationHandlers ? RedirectionViewState.Loading : RedirectionViewState.Failed,
    };
  }),
  on(RedirectionFailedAction, (state) => {
    return {
      ...state,
      viewState: RedirectionViewState.Failed,
    };
  })
);
